<template>
  <v-dialog v-model="internalValue" max-width="480" persistent>
    <v-card elevation="8" class="pa-4 rounded-lg">
      <v-card-title class="text-h6 font-weight-bold red--text mb-2">
        <v-icon color="red" left>mdi-alert-circle</v-icon>
        {{ $t("confirm_deletion") }}
      </v-card-title>

      <v-card-text class="body-1 text--secondary mb-4">
        {{ $t("delete_warning") }}
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text @click="cancel" class="text-capitalize">
          {{ $t("cancel") }}
        </v-btn>
        <v-btn color="red darken-2" dark @click="confirm" class="text-capitalize">
          <v-icon left>mdi-delete</v-icon>
          {{ $t("delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean
  },
  data() {
    return {
      internalValue: this.value
    };
  },
  watch: {
    value(val) {
      this.internalValue = val;
    },
    internalValue(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    cancel() {
      this.internalValue = false;
    },
    confirm() {
      this.$emit("confirm");
      this.internalValue = false;
    }
  }
};
</script>
